exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Roboto:300,400,500,700);", ""]);

// module
exports.push([module.id, ".client-branchces {\n  margin-top: 20px;\n  height: calc(100vh - 170px); }\n  .client-branchces .table-box {\n    overflow: auto;\n    max-height: calc(100vh - 290px); }\n  .client-branchces ::-webkit-scrollbar-thumb {\n    background-color: silver; }\n  .client-branchces ::-webkit-scrollbar {\n    width: 7px;\n    height: 7px; }\n\n@media screen and (max-width: 600px) {\n  .client-branchces {\n    margin: 20px 10px 0;\n    width: calc(100vw - 20px);\n    overflow: auto; }\n    .client-branchces .custom-table {\n      padding: 0 2px; }\n    .client-branchces .table-box {\n      max-height: calc(100vh - 360px) !important; } }\n\n/*\n@media screen and (max-width: 400px){\n    .client-branchces {\n        width: 300px;\n    }\n}*/\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/sass-loader/lib/loader.js!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/screens/clients/detail/branches/index.scss
// module id = 1234
// module chunks = 0